import { render, staticRenderFns } from "./AdminReservations.vue?vue&type=template&id=e5f2d4b6&"
import script from "./AdminReservations.vue?vue&type=script&lang=js&"
export * from "./AdminReservations.vue?vue&type=script&lang=js&"
import style0 from "./AdminReservations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports